<template>
  <div>
    <PageTagline :elements="tagline_elem"/>
    <!-- Overlay di caricamento -->
    <CustomOverlay :show="overlay_show" text="Richiesta in corso, attendere...">

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['tutorial_prevideza_integrativa']"/>

      <!-- CARD PRINCIPALE DI CONTENIMENTO DI TUTTO IL FORM -->
      <b-card :title="form_name" class="mr-1 ml-1">


        <!-- MODALE CON INFO STATICHE PER L'UTENTE - SOSTITUISCE I BLOCCHI COLORATI IN CIMA AL FORM -->
        <b-modal ref="static-info-modal"
          title="Previdenza Integrativa - Note per l'utente"
          no-close-on-esc
          no-close-on-backdrop
          hide-header-close
          size='xl'>
          <p class="text-justify">
            Se sei iscritto ad un fondo di previdenza complementare, puoi utilizzare il tuo credito welfare per effettuarne il pagamento.
            Ricerca nell'apposito campo il codice COVIP o il nome del fondo a cui desideri versare e selezionalo dall'elenco dei risultati ottenuti;
            completa il modulo inserendo l'importo che vuoi destinare a Previdenza Integrativa.
          </p>
          <p class="h6">Quali informazioni devo indicare?</p>
          <p class="text-justify">
            Le informazioni da indicare sono semplicemente quelle relative al nome del fondo o il suo codice COVIP al quale hai aderito seguendo
            le indicazioni; deve essere indicata la cifra che desidera venga versata al fondo da te scelto, a titolo di Previdenza Integrativa.
          </p>
          <p class="h6">Quali sono i fondi accettati?</p>
          <p class="text-justify">
            I fondi accettati, sui quali puoi chiedere di effettuare il versamento desiderato, sono quelli autorizzati dalla COVIP, che è l'Autorità
            amministrativa indipendente che ha il compito di vigilare sul buon funzionamento del sistema dei fondi pensione a tutela degli aderenti
            e dei loro risparmi destinati a previdenza complementare (<b-link href="https://www.covip.it/" target="_blank">https://www.covip.it/</b-link>).
          </p>
          <template #modal-footer="{ cancel }">
            <b-button size="sm" variant="primary" @click="cancel()">
              Chiudi
            </b-button>
          </template>
        </b-modal>

        <!-- DATI DEL FONDO ATTUALE AL QUALE L'UTENTE E' ISCRITTO -->
        <b-form @submit.prevent="onSubmit">
          <b-card title="Il mio fondo" class="ml-1 mr-1 mt-2 mb-2">

            <!-- Link all'informativa -->
            <b-link class="mb-3" :href="url_informativa" target="_blank">
              <b-icon class="mr-2" icon="info-circle"></b-icon>Informativa previdenza integrativa
            </b-link>

            <!-- Checkbox disclaimer -->
            <b-form-group id="group-prev-check"
              label="* Iscrizione:"
              label-for="prev-check">
              <b-form-checkbox
                id="prev-check"
                v-model="form.prev_ok"
                name="prev-check"
                :value="true"
                :unchecked-value="false"
                class="font-italic"
                required
              >
                Dichiaro di aver aderito al fondo di previdenza integrativa sotto indicato, al quale chiedo di effettuare un versamento di importo pari a
                quanto indicato nell'apposito campo Ricerca e di aver letto e compreso l’informativa presente nell’area <b-link :to="{ 'name' : 'site-documentazione', 'params': { 'group_to_show' : 'conv-previdenza-integrativa' } }">“Documentazione”</b-link> o nel link qui sopra.
              </b-form-checkbox>
            </b-form-group>


            <!-- Ricerca del fondo - Autocomplete -->
            <!-- La ref="ricerca_fondo" ci serve per poterlo resettare da codice -->
            <b-form-group id="group-ricerca"
              label="Ricerca:"
              label-for="ricerca"
              description="Ricerca per nome del fondo, codice COVIP od istituto.">
              <vue-bootstrap-typeahead
                v-model="chiave_ricerca"
                :data="fondi_datalist"
                @hit="aggiorna_campi_fondo"
                ref="ricerca_fondo">
                <template v-slot:prepend>
                    <b-input-group-text><b-icon icon="search"></b-icon></b-input-group-text>
                </template>
              </vue-bootstrap-typeahead>
            </b-form-group>

            <!-- Stringa che indica lo stato attuale del fondo utente -->
            <p v-if="form.covip===null" class="text-danger">Non risulta ancora selezionato nessun fondo pensionistico su cui effettuare versamenti, cerca e selezionane uno tra quelli disponibili.</p>
            <p v-else-if="form.covip === user_init_data.covip" class="text-info">Hai già eseguito in passato versamenti sul fondo indicato di seguito. Puoi continuare ad utilizzarlo o decidere di cambiarlo ricercandone uno nuovo.</p>
            <div v-else-if="form.covip !== user_init_data.covip">
              <p class="text-danger">Hai variato il tuo fondo, ti sarà richiesta una ulteriore conferma prima di procedere all'invio della richiesta, oppure annulla la variazione ora: 
                <b-button variant="outline-danger" class="ml-1" size="sm" @click="ripristina_fondo_iniziale">annulla variazione fondo</b-button>
              </p>
            </div>

            <!-- Istituto del fondo -->
            <b-form-group id="group-istituto"
              label="* Istituto:"
              label-for="istituto">
              <b-form-input
                id="istituto"
                v-model="form.istituto"
                :disabled="true"
                required
              ></b-form-input>
            </b-form-group>

            <!-- Nome del fondo -->
            <b-form-group id="group-nome-fondo"
              label="* Nome del fondo:"
              label-for="nome-fondo">
              <b-form-input
                id="nome-fondo"
                v-model="form.nome"
                :disabled="true"
                required
              ></b-form-input>
            </b-form-group>

            <!-- Codice covip del fondo -->
            <b-form-group id="group-covip-fondo"
              label="* Codice fondo (COVIP):"
              label-for="covip-fondo">
              <b-form-input
                id="covip-fondo"
                v-model="form.covip"
                :disabled="true"
                required
              ></b-form-input>
            </b-form-group>

            <!-- Importo da versare sul fondo -->
            <b-form-group id="group-importo"
              label="* Importo da versare:"
              :invalidFeedback="importo_help_text"
              label-for="importo">
              <b-input-group prepend="€">
                <b-form-input
                  id="importo"
                  v-model="form.importo"
                  @keyup="check_importo"
                  :state="importo_state"
                  required
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <!-- Campo note -->
            <b-form-group id="group-note"
              label="Note:"
              label-for="note">
              <b-form-textarea
                id="note"
                v-model="form.note"
                placeholder="Scrivi qui eventuali note per i nostri operatori."
                rows="5"
                max-rows="5"
              ></b-form-textarea>
            </b-form-group>

          </b-card>

          <!-- DATI DELL'UTENTE -->
          <b-card title="I miei dati anagrafici" class="ml-1 mr-1 mt-2 mb-2">

            <!-- Nome utente -->
            <b-form-group id="group-nome-utente"
              label="Nome:"
              label-for="nome-utente">
              <b-form-input
                id="nome-utente"
                v-model="user_data.nome"
                :disabled="true"
              ></b-form-input>
            </b-form-group>

            <!-- Cognome utente -->
            <b-form-group id="group-cognome-utente"
              label="Cognome:"
              label-for="cognome-utente">
              <b-form-input
                id="cognome-utente"
                v-model="user_data.cognome"
                :disabled="true"
              ></b-form-input>
            </b-form-group>

            <!-- Cognome utente -->
            <b-form-group id="group-cod-fisc"
              label="Cod. Fiscale:"
              label-for="cod-fisc">
              <b-form-input
                id="cod-fisc"
                v-model="user_data.cod_fisc"
                :disabled="true"
              ></b-form-input>
            </b-form-group>

          </b-card>

          <!-- Pulsante di invio -->
          <b-button type="submit" variant="primary" class="mr-1">Invia richiesta</b-button>

        </b-form>
      </b-card>
    </CustomOverlay>
    <!-- Modale da visualizzare con l'informativa se il flag previdenza_is_ok della tabella wf_anagrafica è a false -->
    <b-modal v-model="info_modal_show" title="Comunicazione" size="xl"
            :no-close-on-esc="true"
            :no-close-on-backdrop="true"
            :scrollable="true"
            :hide-header-close="true"
            :hide-footer="true">
      <b-row>
        <b-col class="text-justify">
          <p>Gentile Utente,</p>
          <p>accedendo all’area Previdenza Complementare della piattaforma è necessario che lei prenda conoscenza di elementi normativi che regolano l’utilizzo del credito per questa voce di spesa. La invitiamo ad attenersi a quanto indicato nel documento qui sotto riportato e disponibile anche nell'area documenti o cliccando <b-link :href="url_informativa" target="_blank">qui</b-link> che avrà cura di leggere con attenzione prima di procedere oltre. Per esigenze che esulano da quanto riportato nel documento la preghiamo di consultare l’area FAQ o eventualmente rivolgersi alla nostra assistenza.</p>
          <p>Cordiali saluti</p>
          <hr>
          <h4>INFORMATIVA SU COME UTILIZZARE IL PROPRIO CREDITO WELFARE PER COSTITUIRE O RINFORZARE LA PENSIONE INTEGRATIVA</h4>
          <p>Se il dipendente ha a disposizione un credito welfare, può decidere di impiegarlo per versarlo, in tutto o in parte, tramite il datore ad un fondo di previdenza complementare; quindi nel caso di utilizzo del credito welfare nella direzione della previdenza complementare, il datore versa un contributo conto ditta a previdenza complementare erodendo il credito welfare del dipendente.</p>
          <p>Il dipendente può versare (in linea teorica, tramite il datore ed utilizzando il suo credito welfare), ad un fondo negoziale (es. COMETA), ad un fondo aperto (ad adesione collettiva-individuale), oppure ad piano pensionistico individuale (PIP).</p>
          <p>Esempio: Dipendente con CCNL metalmeccanica industria. E’ iscritto al fondo di previdenza complementare Cometa (fondo negoziale) e versa a questo fondo, tramite il datore, il TFR, il contributo c/dipendente (1,20% sulla retribuzione, € 300,00) e contributo c ditta (2% sulla retribuzione € 450,00). Il datore ha messo a disposizione per tutti i dipendenti nel 2018 (periodo 1/1/2018-31/12/2018)
             un credito welfare del valore di € 1.000,00, tramite un regolamento aziendale per il welfare. Nel caso in cui il dipendente decida di destinare il credito welfare alla previdenza complementare, l’unico fondo a cui sono versabili i € 1.000,00 è il Cometa (ovvero il fondo a cui per il tramite del datore sono dirottati i contributi ordinari-non agganciati al welfare- alla previdenza complementare</p>
          <p>Il versamento di contributi a previdenza complementare (ordinario c/dipendente + contributo c/ditta + contributo c/ditta tramite utilizzo del credito welfare) è deducibile nel limite di euro € 5.164,57 in ragione di anno.</p>
          <p>Di conseguenza il dipendente potrebbe versare, tramite il datore oppure direttamente come persona fisica, contributi a previdenza complementare che eccedono -in ragione di anno- questo limite; tuttavia l’eccedenza rispetto ad euro € 5.164,57 diventa imponibile fiscale.</p>
          <p>Al dipendente è consentito di alzare tale limite di deducibilità di altri € 3.000,00, nel caso in cui lo stesso sia destinatario di un premio di risultato detassato da accordo di secondo livello: in tal caso se il dipendente matura un premio detassabile di € 3.000,00 e lo converte, in tutto o in parte, in contributi c/ditta alla previdenza complementare (sempre che il contratto di secondo livello consenta l’opzione ),
             la cifra utilizzata non concorre alla formazione del suo imponibile fiscale fino ad € 8.164,57 (€ 5164,57+ € 3.000,00 = € 8.164,57).</p>
          <p>Si sottolinea che nel caso in cui il dipendente stia versando, tramite il datore, il contributo ordinario (esempio contributo c/dipendente + c/ditta, è irrilevante il versamento del TFR) ad un fondo negoziale (es. Cometa), nel caso di opzione del credito welfare in contributi c/ditta previdenza complementare, la scelta del fondo non è libera: infatti, in tal caso il contributo c/ditta da credito welfare, va necessariamente versato al fondo a cui si destinano i contributi ordinari.</p>          
        </b-col>
      </b-row>
      <!-- Form per l'accettazione dell'informativa -->
      <b-row align-h="end">
        <b-col md="6">
          <b-form @submit.prevent="accetta_informativa">
            <b-form-group id="group-ok-informativa">
              <b-form-checkbox
                  id="ok-informativa"
                  name="ok-informativa"
                  :value="true"
                  :unchecked-value="false"
                  v-model="previdenza_is_ok"
                  required>
                <span class="font-weight-bold">Dichiaro di aver preso visione e di avere ben compreso le indicazioni e gli esempi sopra illustrati, e di poter effettuare quindi una scelta consapevole e convinta circa la mia previdenza integrativa.</span>
              </b-form-checkbox>
            </b-form-group>
            <div class="text-center">
              <b-button type="submit" class="mr-2" variant="primary">
                Accetta e Continua
              </b-button>
              <b-button type="button" variant="warning" @click="annulla_informativa">
                Annulla
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>



<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import TutorialContestuale from '@/components/TutorialContestuale'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'PrevidenzaIntegrativa',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Previdenza integrativa", link : 'conv-previdenza-integrativa' } ],
      form_name : "Previdenza Integrativa",
      form_kind : 7, // il kind del rimborso interessi
      overlay_show: false, // overlay con spinner per indicare che il sistema sta lavorando
      url_informativa: null, // url del pdf dell'informativa da prendere da backend

      // Dati per la modale dell'informativa
      // Flag per la visualizzazione della modale
      info_modal_show: false,
      // stato della checkbox di accettazione
      previdenza_is_ok: false,

      // Chiave di ricerca del fondo
      chiave_ricerca : null,

      // Array per la datalist di ricerca dei fondi
      fondi_datalist: [],

      // Flag di stato per l'importo
      importo_state: null,

      // Dati del form da inviare al backend
      form : {
        prev_ok : false,
        istituto : null,
        nome : null,
        covip : null,
        importo : null,
        note : null,
      },

      // I dati utente da mostrare a schermo
      user_data : {
        nome : this.$store.state.user.user_anag.nome,
        cognome : this.$store.state.user.user_anag.cognome,
        cod_fisc : this.$store.state.user.user_anag.cod_fisc
      },

      // Dati iniziali del fondo associato all'utente che carichiamo
      // in fase di creazione del componente, in questo modo possiamo
      // facilmente tornare indietro se l'utente modifica il fondo
      // e ci ripensa
      user_init_data : {
        istituto : null,
        nome : null,
        covip : null,
      }
    }
  },
  computed : {
    /**
     * Visualizza un avviso per l'utente se dalla validazione della casella
     * dell'importo si evince che sta sforando il suo credito welfare.
     */
    importo_help_text : function () {
      if ( this.importo_state === false ) {
        let credito = this.$store.state.user.user_credito.totale;
        let mess = "Attenzione, l'importo immesso supera il tuo attuale credito welfare che è di " +
                    credito + " euro. Non sarai in grado di completare la procedura."
        return mess;
      } else {
        return '';
      }
    }
  },
  methods: {
    onSubmit : function () {

      // Se il covip del fondo è variato rispetto a quello scelto inizialmente dall'utente glielo
      // dobbiamo notificare prima di procedere.
      if ( this.user_init_data.covip != null && parseInt( this.form.covip ) !== parseInt( this.user_init_data.covip ) ){
        let message = "Sei sicuro di modificare l'attuale fondo? Continuando il nuovo fondo sarà associato al tuo profilo."
        this.$bvModal.msgBoxConfirm( message, {
          title: 'Conferma Modifica Fondo',
          okTitle: 'Conferma',
          cancelTitle: 'Annulla',
          footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true
        })
        .then( value => {
          if ( value === false ) {
            // Ripristiniamo i valori precedenti
            this.ripristina_fondo_iniziale();
          } else {
            // Procediamo!
            this.esegui_submit_dati();
          }
        })
        .catch(err => {
          console.error( err );
        })
      } else {
        // E' la prima volta che l'utente setta un fondo possiamo subito procedere.
        this.esegui_submit_dati();
      }

    },
    /**
     * Invia i dati del form al backend per dare seguito alla pratica.
     */
    esegui_submit_dati : function () {

      let data_to_send = Object.assign( {}, this.form );

      // Di fatto ci serve solo il codice covip del fondo quindi possiamo
      // remuovere il nome del fondo e dell'istituto.
      delete data_to_send.nome;
      delete data_to_send.istituto;

      // Controlliamo il campo note. Se l'utente passa sopra al campo ma non lo riempie,
      // questo da una stringa vuota che non è accettata dal backend( abbiamo deciso di dare solo
      // allow_null e non allow_blanck al campo django per non avere un doppio valore accettato ).
      // Quindi se c'è la stringa vuota settiamo il campo a null.
      if ( data_to_send.note !== null && data_to_send.note.trim() === "" ) {
        data_to_send.note = null;
      }

      generalLib.acquisto_confirm_message_box (  this, this.form.importo, 'totale' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla.
        if ( !value ) return;

        // Se invece l'utente decide di proseguire attivo
        // l'overlay e poi eseguo il post delle info.
        this.overlay_show = true;

        axios.post( apiUrl.welfareapi.create_acq_prevint , data_to_send )
        .then( (response) => {

          // Aggiorniamo le info utente sul fondo perchè se torniamo qui dopo la richiesta ed il fondo
          // è variato, vedremo ancora quelle vecchie.
          this.$store.commit( 'update_covip_fondo', this.form.covip );

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home.
          generalLib.acquisto_complete_message_box( this, response.data.id_acquisto )
          .then ( ( val ) => {
              this.$router.push( { name : 'menu'} );
          });

        })
        .catch( (error) => {
            this.overlay_show = false;
            generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });

    },
    /**
     * Controlliamo che l'importo in euro sia nel formato corretto,
     * altrimenti rimuoviamo l'ultimo carattere scritto dall'utente.
     */
    check_importo : function () {
      if ( !generalLib.euro_is_valid( this.form.importo ) ){
        this.form.importo = this.form.importo.slice(0,this.form.importo.length - 1);
      }
    },
    /**
     * Scelto il fondo dalla casella di ricerca utilizzo le regex per spezzare la stringa
     * ed aggiornare i campi del fondo.
     */
    aggiorna_campi_fondo : function ( val ) {
      let reg = /(.*)\[(.*)\](.*)/g;
      let res = reg.exec( val );

      // Se la stringa è ok ho tre gruppi, il primo in prosione uno è il codice covip
      // il secondo è l'istituto ed il terzo il nome del gruppo
      this.form.covip = res[1].trim();
      this.form.istituto = res[2].trim();
      this.form.nome = res[3].trim();

      // Resettiamo il contenuto del campo e della chiave di ricerca
      this.$refs.ricerca_fondo.inputValue = "";
      this.chiave_ricerca = null;
    },
    /**
     * Ripristina nel form i dati originari del fondo associato all'utente
     */
    ripristina_fondo_iniziale : function () {
      this.form.istituto = this.user_init_data.istituto;
      this.form.nome = this.user_init_data.nome;
      this.form.covip = this.user_init_data.covip;
    },
    /**
     * Se stiamo operando in versione replay ( la prop id_acq_replay è settata ), va
     * a prendere i dati da usare per questo nuovo acquisto da un acquisto passato il cui
     * id viene passato dal router e posto per l'appunto nella prop id_acq_replay.
     */
    get_replay_data : function () {

      if ( this.id_acq_replay === null ) return;

      let api_url = apiUrl.welfareapi.acq_info_full.replace( '@id_acquisto', this.id_acq_replay );

      axios.get( api_url )
      .then( (response) => {

        // Se per qualche motivo l'acquisto non ha il kind giusto, non possiamo popolare il form.
        if ( response.data.kind != this.form_kind ) return;

        // Vado a popolare solo l'importo ed il campo note, la modifica del fondo
        // dovrà essere fatta esplicitamente dall'utente
        this.form.importo = response.data.acquisto_row.importo_totale;
        this.form.note = response.data.note.note.note;

      })
      .catch( (error) => {
        generalLib.backend_error_message_box( this, error.response.data );
      })
    },
    /**
     * Funzione che carica nella variabile preposta il link al file pdf dell'informativa
     * che viene linkato nella modale di apertura che si visualizza la prima volta ed in
     * cima nel form.
     */
    get_link_informativa : function () {
      let links_api_url = apiUrl.staticlinks.get_link.replace( '@ltype', 'documentazione' );
      links_api_url = links_api_url.replace('@slug_name' , 'informativa_previdenza_integrativa' );

      axios.get( links_api_url )
      .then( ( response ) => {
        this.url_informativa = response.data.url;
      })
      .catch( ( error ) => {
        // In caso di errore non lo mostriamo a video, si tratta solo di un linkù
        // ad un file, lo mostriamo in console.
        console.error( error )
      });
    },
    /**
     * Funzione per l'invio dei dati di accettazione dell'informativa.
     */
    accetta_informativa : function () {
      axios.post( apiUrl.welfareapi.informativa_prevint, { previdenza_is_ok : this.previdenza_is_ok } )
      .then( ( response ) => {
        // Se la risposta torna correttamente da un 204 no content, quindi l'unica cosa da fare
        // e' chiudere la modale ed aggiornare il flag nello store altrimenti rimarrebbe disallineato.
        this.info_modal_show = false;
        this.$store.commit( 'update_previdenza_is_ok', this.previdenza_is_ok );
      })
      .catch( ( error ) => {
        generalLib.backend_error_message_box( this, error.response.data );
      });
    },
    /**
     * Se l'informativa viene rigettata veniamo riportati al menù iniziale.
     */
    annulla_informativa : function () {
      this.$router.push( { name : 'menu' } );
    }
  },
  created : function () {
    /**
     * Se il flag anagrafica_is_ok è false, viene visualizzata la modale informativa dove l'utente
     * deve fleggare il consenso.
     * Carichiamo poi il link del pdf con l'informativa da visualizzare.
     * Carichiamo poi i dati del fondo utente attuale partendo dal codice covip che è in anagrafica,
     * se è già presente un codice codice covip, altrimenti non viene caricato nulla.
     * Se siamo in modalità replay ( è stata passata la prop id_acq_replay con l'id dell'acquisto ) allora
     * il form viene popolato con tutti i dati che è possibile caricare.
     */

    if ( this.$store.state.user.user_anag.previdenza_is_ok === false ) {
      this.info_modal_show = true;
    }

    this.get_link_informativa();

    let covip_utente = parseInt( this.$store.state.user.user_anag.covip_fondo );
    if ( Number.isNaN( covip_utente ) || covip_utente === 0 ) return;

    let api_url = apiUrl.welfareapi.search_fondo.replace( '@term', covip_utente );
    axios.get( api_url )
    .then( (response) => {
        // Il codice covip è univoco quindi avrò un solo risultato cercando per codice covip
        this.form.covip = response.data[0].covip;
        this.user_init_data.covip = response.data[0].covip;

        // Per avere il nome istituto e nome fondo uso la regex
        let reg = /\[(.*)\](.*)/g;
        let res = reg.exec( response.data[0].nome );

        // Il risultato è la stringa in posizione 0, il primo gruppo ( nome istituto ) in posizione 1
        // ed secondo gruppo ( nome fondo ) in posizione 2
        let nome_ist = res[1].trim();
        let nome_fondo = res[2].trim();

        this.form.istituto = nome_ist;
        this.form.nome = nome_fondo;
        this.user_init_data.istituto = nome_ist;
        this.user_init_data.nome = nome_fondo;

        // Se siamo in modalità replay alcuni dati del form vengono popolati sulla base
        // del precedente acquisto.
        this.get_replay_data();

    })
    .catch( (error) => {
        let mess = "Si è verificato un errore nel caricamento delle informazioni di inizializzazione del form, " +
                   "non sarà possibile concludere correttamente la procedura. " +
                   "Tornare alla homepage e riprovare ad aprire il form. Se il problema persiste " +
                   "contattare l'assistenza."
        generalLib.backend_error_message_box( this, mess );
     });

  },
  /**
   * Quando la pagina è pronta visualizziamo la modale informativa per il servizio.
   */
  mounted : function () {
    this.$refs['static-info-modal'].show();
  },
  watch : {
    /**
     * Verifica in tempo reale se l'importo immesso supera l'attuale disponibilià
     * welfare dell'utente, se sfora segna lo stato dell'importo a false colorando
     * di rosso la casella di input.
     */
    'form.importo' : function ( val ) {
      let importo = parseFloat( val );
      if ( importo > this.$store.state.user.user_credito.totale ){
        this.importo_state = false;
      } else {
        this.importo_state = null;
      }
    },
    /**
     * Eseguiamo la ricerca del fondo per nome, nome istituto o codice covip, il componente non
     * supporta il keyup per questo dobbiamo usare il watch per riempire in maniera lazy l'array
     * dei contenuti trovati.
     */
    chiave_ricerca : function ( val ) {

        if ( val === null ) return;
        if ( val.length < 2 ) return;

        let api_url = apiUrl.welfareapi.search_fondo.replace( '@term', val );
        axios.get( api_url, { params: { limit : 10 } } )
        .then( (response) => {

          this.fondi_datalist = [];
          for ( let elem of response.data ) {
            this.fondi_datalist.push( elem.covip + " " + elem.nome );
          }

        })
        .catch( (error) => {
          console.error( error.response.data );
        });

    }
  },
  props : {
    /**
    * Prop che è passata dal router, se valorizzata indica l'acquisto da replicare
    * inserendo per l'utente i dati nel form.
    */
    id_acq_replay: {
      type: [String, Number],
      default : null
    }
  },
  components : {
    PageTagline,
    CustomOverlay,
    TutorialContestuale
  }
}
</script>

<style scoped>
/* Si tratta di un workaround per fare vedere la stringa di help quando viene usato l'input
   group per far vedere il simboso dell'euro in quanto la classe invalid-feedback di bootstrap 4
   è buggata (https://github.com/twbs/bootstrap/issues/23454) e se usiamo l'input group l'invalid
   feedback non si vede.
   L'uso di ":deep()" serve per dire che la modifica si ripercuote sull'elemento generato dinamicamente
   da bootstrap vue il quale altrimenti non verrebbe toccato dal css ( vedi link al capitolo
   Dynamically Generated Content e poi Deep Selectors):
   https://vue-loader.vuejs.org/guide/scoped-css.html#mixing-local-and-global-styles */
#group-importo :deep( .invalid-feedback ) {
  display: block;
}
</style>